import React from 'react';
import classNames from 'classnames';
import { HyperdbListing } from '../../../../hyperdb';
import { ListingObjects, Modal, DropdownSelector, CheckBoxSelector, CheckBox, Spinner } from 'hyperdb-utils';

class Listing extends React.Component {
  constructor(props) {
    super(props);
    this.handleClickAction = this.handleClickAction.bind(this);
    this.retrySynchronisation = this.retrySynchronisation.bind(this);
    this.handleSelectChannel = this.handleSelectChannel.bind(this);
    this.handleSelectProperties = this.handleSelectProperties.bind(this);
    this.handleClickSelect = this.handleClickSelect.bind(this);
    this.handleClickSelectAllTypes = this.handleClickSelectAllTypes.bind(this);
    this.handleSelectTypes = this.handleSelectTypes.bind(this);
    this.createSynchronisations = this.createSynchronisations.bind(this);
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.postDataSuccessful) {
      this.props.api.synchronisation.setData({
        postDataSuccessful: false,
        selectedSynchronisation: null,
        showModalRetry: false,
        showModalCreate: false,
        selectedChannel: null,
        propertiesForSync: null,
      });
      this.props.api.synchronisation.fetchListing();
    }
  }
  componentWillUnmount() {
    this.props.api.synchronisation.setData({
      selectedSynchronisation: null,
      showModalRetry: false,
      showModalCreate: false,
      selectedChannel: null,
      propertiesForSync: null,
    });
  }
  render() {
    return (
      <div style={{height: '100%'}}>
        <ListingObjects
          { ...this.props }
          onClickAction={ this.handleClickAction }
        />
        {
          this.props.showModalRetry
            ? <Modal
                title="Retry"
                onClose={ this.handleClickAction.bind(this, null) }
                onAccept={ this.retrySynchronisation }
                loading={ this.props.loading }
              >
                <div>Are you sure you want to retry this synchronisation ?</div>
              </Modal>
            : null
        }
        {
          this.props.showModalCreate
            ? <Modal
                title="Create synchronisations"
                onClose={ this.toggleModalCreate.bind(this, false) }
                onAccept={ this.createSynchronisations }
                loading={ this.props.api.getState('channel').loading }
              >
                <Spinner show={ this.props.api.getState('channel').loading } />
                <div className="row">
                  <div className="col-md-6">
                    <DropdownSelector
                      label="Channel"
                      placeholder="--- Select ---"
                      value={ (this.props.selectedChannel || {}).id }
                      options={ (this.listChannels() || []).map(c => ({ name: c.name, value: c.id })) }
                      onChange={ this.handleSelectChannel }
                    />
                  </div>
                </div>
                {
                  this.props.selectedChannel
                    ? <div className="row">
                        <div className="col-md-6">
                          <strong>Types</strong><br/>
                          <label><input type="checkbox" checked={ this._allTypesChecked } onClick={ this.handleClickSelectAllTypes } /> Select all</label>
                          {
                            <CheckBoxSelector
                              label={ null }
                              value={ this.props.selectedTypes || [] }
                              options={ this.typesOptions(this.props.selectedChannel) }
                              onChange={ this.handleSelectTypes }
                            />
                          }
                        </div>
                        <div className="col-md-6">
                          <strong>Properties</strong><br/>
                          <label><input type="checkbox" checked={ this._allPropertiesChecked } onClick={ this.handleClickSelect } /> Select all</label>
                          {
                            this.props.propertiesForSync
                              ? <CheckBoxSelector
                                  label={ null }
                                  value={ this.props.selectedPropertiesIds || [] }
                                  options={ this.props.propertiesForSync.map(p => ({ name: p.name, value: p.id })) }
                                  onChange={ this.handleSelectProperties }
                                />
                              : null
                          }
                        </div>
                      </div>
                    : null
                }
              </Modal>
            : null
        }
      </div>
    );
  }

  handleClickAction(object, actionName) {
    if (!object) return this.props.api.synchronisation.setData({ selectedSynchronisation: null, showModalRetry: false });
    this.props.api.synchronisation.setData({ selectedSynchronisation: object, showModalRetry: true });
  }
  retrySynchronisation() {
    this.props.api.synchronisation.postData({
      url: `/${this.props.selectedSynchronisation.id}/retry`,
      data: {},
    });
  }

  toggleModalCreate(bool) {
    this.props.api.synchronisation.setData({ showModalCreate: bool, selectedChannel: null });
  }
  listChannels() {
    return this.props.api.getState('channel').channelsForSync;
  }
  handleSelectChannel(field) {
    const selectedChannel = this.listChannels().find(c => c.id === field.value);
    this.props.api.synchronisation.setData({ selectedChannel });
    this.props.api.channel.getData({ url: `/${selectedChannel.id}/get-properties-on-channel` })
      .then(propertiesForSync => {
        this._allPropertiesChecked = true;
        this._allTypesChecked = true;
        const selectedPropertiesIds = propertiesForSync.map(p => p.id);
        const selectedTypes = this.typesOptions(selectedChannel).map(t => t.value);
        this.props.api.synchronisation.setData({ selectedPropertiesIds, selectedTypes, propertiesForSync });
      });
  }
  handleSelectProperties(field) {
    const selectedPropertiesIds = field.value;
    this.props.api.synchronisation.setData({ selectedPropertiesIds: field.value });
  }
  handleClickSelect() {
    this._allPropertiesChecked = !this._allPropertiesChecked;
    const selectedPropertiesIds = this._allPropertiesChecked ? this.props.propertiesForSync.map(p => p.id) : [];
    this.props.api.synchronisation.setData({ selectedPropertiesIds });
  }
  typesOptions(selectedChannel) {
    const types = [];
    const settings = selectedChannel.settings || {};
    if (settings.send_property_details) types.push('property_details');
    if (settings.send_prices) {
      types.push('static_prices');
      types.push('seasonal_prices');
    }
    if (settings.send_conditions) {
      types.push('static_conditions');
      types.push('seasonal_conditions');
    }
    if (settings.send_availability) types.push('availability');
    return types.map(t => ({ name: t, value: t }));
  }
  handleSelectTypes(field) {
    const selectedPropertiesIds = field.value;
    this.props.api.synchronisation.setData({ selectedTypes: field.value });
  }
  handleClickSelectAllTypes() {
    this._allTypesChecked = !this._allTypesChecked;
    const selectedTypes = this._allTypesChecked ? this.typesOptions(this.props.selectedChannel).map(t => t.value) : [];
    this.props.api.synchronisation.setData({ selectedTypes });
  }
  createSynchronisations() {
    if (this.props.selectedChannel) {
      this.props.api.channel.postData({
        url: `/${this.props.selectedChannel.id}/force-synchronisations`,
        data: {
          propertiesIds: this.props.selectedPropertiesIds,
          types: this.props.selectedTypes,
        }
      })
      .then(() => {
        this.props.api.synchronisation.setData({ postDataSuccessful: true });
      });
    }
  }
}

export default HyperdbListing({
  CustomComponent: Listing,
  collectionName: 'synchronisations',
  namespace: 'synchronisation',
  mountedUrl: '/synchronisations',
  title: 'Synchronisations',
  columns: [
    { attribute: 'date', label: 'date' },
    { attribute: 'property.name', label: 'property' },
    { attribute: 'type' },
    { label: 'status', value: displayStatus },
    { label: 'parameters', value: displayParameters },
  ],
  actions: [
    { name: 'retry', label: 'Retry', display: canRetry },
  ],
  onNew: (props) => {
    props.api.channel.getObjects({
      propName: 'channelsForSync',
      queryOptions: [['id', 'name', 'settings'], { where: { enabled: true, type: 'output' }, order: { name: 'asc' } }],
    });
    props.api.synchronisation.setData({ showModalCreate: true });
  },
  canEdit: false,
});

function displayStatus(object) {
  return (
    <ul>
    {
      object.channels.map((channel, i) => {
        let status = channel.status;
        if (status === 'pending' && channel.nb_fails >= 1) status = 'processing';
        if (status === 'error') status = `${status}: ${channel.error || ''}`;
        return (<li key={ i }><strong>{ channel.channel_name }</strong>: { status }</li>);
      })
    }
    </ul>
  );
}
function displayParameters(object) {
  return (
    <div>
    {
      Object.keys(object.parameters.data).map((attr, i) => {
        return <div>{ attr }: { String(object.parameters.data[attr]) }</div>;
      })
    }
    </div>
  );
}
function canRetry(object) {
  if (!object.error) return false;
  return object.channels.every(channel => channel.status === 'error' || channel.status === 'success');
}



// WEBPACK FOOTER //
// ./src/frontend/modules/inventory/synchronisation/containers/Listing.jsx